module.exports = __webpack_public_path__ + "img/Angiogenesis-LUCA_10X_LU.70bf0cb9.png";